/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import './../App.css'
import './group.css'
//import { useNavigate, BrowserRouter as Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { buildHttpGet } from "./utils/backendInterface.js";
import { buildTable } from "./utils/table.js";
import { isDev } from "./utils/helper.js";

const TAB_NAME__TERMINALS = "terminals";
const TAB_NAME__ACCOUNTS = "accounts";
const TAB_NAMES = [TAB_NAME__TERMINALS, TAB_NAME__ACCOUNTS];
const TAB_COLOR_SELECTED = "#000000";
const TAB_COLOR_UNSELECTED = "#36454F";


const Group = () => {
    const navigate = useNavigate();
    let count = 0;
    let _isDev = isDev();
    let pathArray = window.location.pathname.split('/');
    let companyId;
    let groupId;
    let updateUrl = false;
    if (pathArray.length > 2 && pathArray[1] === "companies" && pathArray[2] !== undefined) {
        companyId = pathArray[2];
        sessionStorage.setItem("lastSelectedCompany", companyId);
    } else {
        companyId = sessionStorage.getItem("lastSelectedCompany");
        updateUrl = true;
    }
    if (pathArray.length > 4 && pathArray[3] === "groups" && pathArray[2] !== undefined) {
        groupId = pathArray[4];
        sessionStorage.setItem("lastSelectedGroup", groupId);
    } else {
        groupId = sessionStorage.getItem("lastSelectedGroup");
        updateUrl = true;
    }
    console.log('Group page loaded. companyId: ' + companyId + ' groupId: '+ groupId);

    let accessToken = sessionStorage.getItem("accessToken");
    let terminalsJson;
    let accountsJson;
    let displayedTab = TAB_NAME__TERMINALS;

    function setTextColorTabs() {
        TAB_NAMES.forEach((tabName) => {
            let tabElement = document.getElementById("tab-" + tabName);
            if (tabElement) {
                if (tabName === displayedTab) {
                    tabElement.style.color = TAB_COLOR_SELECTED;
                } else {
                    tabElement.style.color = TAB_COLOR_UNSELECTED;
                }
            }
        });
    }

    function redirectToCreateTerminals() {
        if (companyId === undefined && groupId === undefined) {
            return;
        }
        let createCroupTerminal = document.getElementById("create-terminals-button");
        if (createCroupTerminal) {
            createCroupTerminal.href = '/companies/' + companyId + '/groups/' + groupId + '/create-terminals';
            console.log("Create terminals ref: " + createCroupTerminal.href);

        } else {
            console.log("Unable to determine createCroupTerminal");
        }
    }

    function redirectToCreateAccounts() {
        if (companyId === undefined && groupId === undefined) {
            return;
        }
        let createCroupTerminal = document.getElementById("create-accounts-button");
        if (createCroupTerminal) {
            createCroupTerminal.href = '/companies/' + companyId + '/groups/' + groupId + '/create-accounts';
            console.log("Create accounts ref: " + createCroupTerminal.href);

        } else {
            console.log("Unable to determine createTerminals");
        }
    }

    function onClickTerminalsTab() {
        if (displayedTab === TAB_NAME__TERMINALS) {
            return;
        }
        displayedTab = TAB_NAME__TERMINALS;
        setTextColorTabs();
        displayTerminals();
    }

    function onClickAccountsTab() {
        if (displayedTab === TAB_NAME__ACCOUNTS) {
            return;
        }
        displayedTab = TAB_NAME__ACCOUNTS;
        setTextColorTabs();
        displayAccounts();
        window.scrollTo(0, 0);
    }

    function displayTerminals() {
        let requestParams = new Map();
        requestParams.set("accessToken", accessToken);

        function alertContents(httpRequest) {
            if (httpRequest && httpRequest.readyState === XMLHttpRequest.DONE) {
                console.log("httpRequest.status: " + httpRequest.status);
                if (httpRequest.status === 200) {
                    console.log("Got terminals success");
                    console.log("Body: " + httpRequest.responseText);
                    terminalsJson = JSON.parse(httpRequest.responseText);
                    buildTable("group-container", ["Serial number", "Pos ID", "Terminal name"], ["serialNumber", "posId", "terminalName"], terminalsJson, navigate, "_id", "/terminals/");
                } else if (httpRequest.status === 403) {
                    console.log("Get terminals denied. Status: " + httpRequest.status + " Error: " + httpRequest.thrownError);
                    alert('Failed to get terminals');
                } else {
                    alert("There was a problem with the request: ", httpRequest.status);
                }
            }
        }

        let httpRequest = buildHttpGet('companies/' + companyId + '/groups/' + groupId  + '/terminals', requestParams, alertContents);
        httpRequest.sendRequest();
    }

    function displayAccounts() {
        let requestParams = new Map();
        requestParams.set("accessToken", accessToken);

        function alertContents(httpRequest) {
            if (httpRequest && httpRequest.readyState === XMLHttpRequest.DONE) {
                console.log("httpRequest.status: " + httpRequest.status);
                if (httpRequest.status === 200) {
                    console.log("Got accounts success");
                    console.log("Body: " + httpRequest.responseText);
                    accountsJson = JSON.parse(httpRequest.responseText);
                    buildTable("group-container", ["Token", "Group type", "Balance"], ["token", "groupType", "balance"], accountsJson, navigate, "_id", "/group/");
                } else if (httpRequest.status === 403) {
                    console.log("Get accounts denied. Status: " + httpRequest.status + " Error: " + httpRequest.thrownError);
                    alert('Failed to get accounts');
                } else {
                    alert("There was a problem with the request: ", httpRequest.status);
                }
            }
        }

        let httpRequest = buildHttpGet('companies/' + companyId + '/groups/' + groupId  + '/accounts', requestParams, alertContents);
        httpRequest.sendRequest();
    }

    useEffect(() => {
        count = count + 1;
        console.log("On page load: " + count);
        if (count === 1 && _isDev) {
            return;
        }
        if (!accessToken) {
            navigate('/sign-in');
            return;
        } else if (!sessionStorage.getItem("accessToken")) {
            return;
        }

        console.log("On page load");

        if (updateUrl) {
            navigate('companies/' + companyId + '/groups/' + groupId);
        }

        let editCompanyLink = document.getElementById("link-edit-company");
        if(editCompanyLink) {
            editCompanyLink.href = "/create-company/" + companyId;
        }

        if (displayedTab === TAB_NAME__TERMINALS) {
        }
        setTextColorTabs();

        if (companyId === undefined && groupId === undefined) {

        } else if (groupId === undefined) {

        } else {
            redirectToCreateTerminals();
            redirectToCreateAccounts();
            displayTerminals();
        }
    }, [count]);

    return (
        <>
            <h2>Group</h2>
            <nav id="sidebarMenu" className="collapse d-lg-block sidebar collapse bg-white">
                <div className="position-sticky">
                    {/* <div className="list-group list-group-flush mx-3 mt-4">
                        <a href="/create-terminals-button" className="list-group-item list-group-item-action py-2 ripple">
                            <i className="fas fa-lock fa-fw me-3"></i><span>Create terminals</span>
                        </a>
                    </div> */}
                    <div className="list-group list-group-flush mx-3 mt-4">
                        <a id="create-terminals-button" href="#" className="list-group-item list-group-item-action py-2 ripple" >
                            <i className="fas fa-lock fa-fw me-3"></i><span>Create/add terminals</span>
                        </a>
                        <a id="create-accounts-button" href="#" className="list-group-item list-group-item-action py-2 ripple">
                            <i className="fas fa-lock fa-fw me-3"></i><span>Create/add accounts</span>
                        </a>
                    </div>
                </div>
            </nav>
            <div>
                <nav className="navbar navbar-expand-lg navbar-gray" id="navbar-sign-in">
                    <div className="group-container">
                        <div className="navbar-collapse" id="navbar-elements-signed-in">
                            <ul className="navbar-nav ml-auto">
                                <li className="nav-item"><div className="nav-link" id="tab-terminals" onClick={onClickTerminalsTab}>Terminals</div></li>
                                <li className="nav-item"><div className="nav-link" id="tab-accounts" onClick={onClickAccountsTab}>Accounts</div></li>
                                {/* <li className="nav-item"><Link className="nav-link" to={'/companies'}>Companies</Link></li>
                  <li className="nav-item"><Link className="nav-link" to={'/groups'}>Groups</Link></li>
                  <li className="nav-item"><Link className="nav-link" to={'/accounts'}>Accounts</Link></li>
                  <li className="nav-item"><Link className="nav-link" to={'/terminals'}>Terminals</Link></li>
                  <li className="nav-item"><Link className="nav-link" onClick={() => { signOut(); }}>Sign out</Link></li> */}
                            </ul>
                        </div>
                    </div>
                </nav>
            </div >
            <div className="content-box">  {/* This creates the white box */}
                <div className="table-container">  {/* This holds the scrolling table */}
                    <div id="group-container"></div>  {/* This just holds the table */}
                </div>
            </div>
        </>
    );
}

export default Group;
